export default __webpack_public_path__ + "static/artistBox-kou-mariya-73b68057275022bce163a8c71c819f2f.png";